<template>
  <div class="extended-forms">
    <card class="border-card">
      <div class="row pl-3">
        <h4 class="card-title mt-2 mx-0 font-weight-bold">Translate</h4>
        <span>Select one or more target languages to translate your text, if needed.</span>
      </div>

      <div class="row mt-3 pl-3" style="width: 100%;">
        <label>Translate into these languages</label>
        <el-select
          v-model="optionLanguageSelected"
          multiple
          filterable
          :disabled="isTranslating"
          placeholder="Select one or more languages"
          style="width: 100%;"
        >
          <el-option
            v-for="(lang, index) in languagesToSelect"
            :key="index"
            :label="lang.name"
            :value="lang.language_code"
          />
        </el-select>
      </div>

      <div class="row mt-3 pl-3" style="width: 100%;">
        <label>Translation Model</label>
        <el-select
          class="select-primary"
          v-model="translationModel"
          :disabled="isTranslating"
          placeholder="Select translation model"
          style="width: 100%;"
        >
          <el-option
            label="Azure (default)"
            value="azure"
          />
          <el-option
            label="OpenAI"
            value="openai"
          />
          <el-option
            label="Google"
            value="google"
          />
          <el-option
            label="Anthropic"
            value="anthropic"
          />
        </el-select>
      </div>

      <div class="row mt-3 mb-3 px-2">
        <div class="selected-languages w-100">
          <base-button
            @click="sendtranslate"
            :disabled="!optionLanguageSelected.length || isTranslating"
            native-type="submit"
            type="primary"
            class="btn-fill py-3 px-3 btn_add_link regenerate-btn w-100"
          >
            <span v-if="isTranslating">Traduzione in corso...</span>
            <span v-else>Traduci</span>
          </base-button>
        </div>
      </div>

      <div v-if="order" class="w-100 mb-1">
        <card class="border-card pl-3">
          <div class="row">
            <router-link target="_blank" :to="`/orders/${order.order_detail_id}`">
              {{ order.title || stripHtml(order.content).substring(0, 30) + ' ...' }}
            </router-link>
          </div>
          <div class="row">
            <small class="paragraph-translate">
              <span>{{ getFormattedDate(order.timestamp) }}</span>
              <span> - Italian</span>
            </small>
          </div>
        </card>
      </div>

      <div v-if="paginatedDisplayItems.length" class="w-100 mb-1">
        <div
          v-for="item in paginatedDisplayItems"
          :key="item.id"
          class="w-100 mb-3"
        >

          <card v-if="!item.isPlaceholder" class="border-card">
            <router-link v-if="item.order_detail_id" target="_blank" :to="`/orders/${item.order_detail_id}`">
              <div v-html="getPreviewText(item)"></div>
            </router-link>
            <div v-else>
              <div v-html="getPreviewText(item)"></div><br>
            </div>
          </card>

          <card v-else class="border-card is-translating">
            <div class="translated-content">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5155_5800)">
                  <path d="M8 1.83325C4.80267 1.83325 2.17315 4.26697 1.8638 7.38265C1.83652 7.65744 1.59164 7.85809 1.31685 7.8308C1.04206 7.80352 0.841411 7.55864 0.868694 7.28385C1.22832 3.66177 4.28353 0.833252 8 0.833252C10.6243 0.833252 12.9182 2.24371 14.1667 4.34645V1.99992C14.1667 1.72378 14.3905 1.49992 14.6667 1.49992C14.9428 1.49992 15.1667 1.72378 15.1667 1.99992V4.93325C15.1667 5.43031 14.7637 5.83325 14.2667 5.83325H11.3333C11.0572 5.83325 10.8333 5.60939 10.8333 5.33325C10.8333 5.05711 11.0572 4.83325 11.3333 4.83325H13.2927C12.2147 3.03545 10.2473 1.83325 8 1.83325Z" fill="#D32F2F"/>
                  <path d="M14.1691 8.61718C13.8598 11.7329 11.2303 14.1666 8.03292 14.1666C5.7856 14.1666 3.81819 12.9644 2.7402 11.1666H4.69954C4.97569 11.1666 5.19954 10.9427 5.19954 10.6666C5.19954 10.3904 4.97569 10.1666 4.69954 10.1666H1.76621C1.26915 10.1666 0.866211 10.5695 0.866211 11.0666V13.9999C0.866211 14.2761 1.09007 14.4999 1.36621 14.4999C1.64235 14.4999 1.86621 14.2761 1.86621 13.9999V11.6533C3.11463 13.7561 5.40861 15.1666 8.03292 15.1666C11.7494 15.1666 14.8046 12.3381 15.1642 8.71599C15.1915 8.44119 14.9909 8.19631 14.7161 8.16903C14.4413 8.14175 14.1964 8.34239 14.1691 8.61718Z" fill="#D32F2F"/>
                </g>
                <defs>
                  <clipPath id="clip0_5155_5800">
                    <rect width="16" height="16" fill="white"/>
                  </clipPath>
                </defs>
              </svg> <span><strong>Sto traducendo </strong></span><br>
              <small class="paragraph-translate"><span>{{ item.language }}</span></small>
            </div>
          </card>
        </div>
      </div>
      <div v-else class="col-12 py-lg">
        <EmptyContainer :firstLine="'No translations yet!'"
          :secondLine="'Your AI generated translations will appear here.'" />
      </div>

      <div slot="footer" class="col-12 justify-content-center justify-content-sm-between flex-wrap">
        <base-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="totalTranslatedItems"
        />
      </div>
    </card>
  </div>
</template>

<script>
import { Select, Option, Message } from "element-ui";
import { mapGetters } from "vuex";
import { BasePagination } from 'src/components';
import EmptyContainer from "@/pages/Components/EmptyContainer";


let nextTemporaryId = 0;

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    BasePagination,
    EmptyContainer
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    relatedOrders: {
      type: Array,
      default: () => []
    },
    infoTool: {
      type: Object
    }
  },
  data() {
    return {
      displayItems: [],
      optionLanguageSelected: [],
      translationModel: 'azure',
      isTranslating: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      languages: "getLanguages",
      isLoading: "getIsLoading"
    }),
    languagesToSelect() {
      const availableCodes = this.infoTool?.translation ?? [];
      const filteredLanguages = this.languages.filter(lang =>
        availableCodes.includes(lang.language_code)
      );

      return filteredLanguages;
    },
    paginatedDisplayItems() {
      const start = (this.pagination.currentPage - 1) * this.pagination.perPage;
      const end = start + this.pagination.perPage;
      return this.displayItems.slice(start, end);
    },
    totalTranslatedItems() {
      return this.displayItems.length;
    }
  },
  methods: {
    async sendtranslate() {
      if (!this.optionLanguageSelected.length || this.isTranslating) return;

      this.isTranslating = true;

      // Salva la preferenza del modello in localStorage
      localStorage.setItem('preferredTranslationModel', this.translationModel);

      const languagesToRequest = [...this.optionLanguageSelected];
      const tempIdsMap = new Map();
      const awsToLangCode = new Map();

      const languagesToSend = [];

      languagesToRequest.forEach(langCode => {
        const tempId = `temp_${nextTemporaryId++}_${Date.now()}`;
        const lang = this.languages.find(l => l.language_code === langCode);
        languagesToSend.push(lang.aws_language_code);

        const placeholderItem = {
          id: tempId,
          language: lang.name,
          language_code: lang.language_code,
          isPlaceholder: true,
          timestamp: Date.now()
        };

        this.displayItems.splice(0, 0, placeholderItem);
        tempIdsMap.set(lang.aws_language_code, tempId);
        awsToLangCode.set(lang.aws_language_code, langCode);
      });

      const params = {
        user_id: this.$store.getters.getUser.id,
        lang: languagesToSend,
        order_id: this.order.order_id ?? this.order.id,
        title: this.order.title,
        content: this.order.content,
        product_key: this.infoTool.product_key,
        product_keys: this.infoTool.product_keys?.[0] ?? [],
        translate_from: 'it',
        model: this.translationModel,
        fast_api: true
      };

      try {
        const response = await this.$axios.post("/tools/general-translation", params);
        const rawResponseData = response.data;
        let newTranslations = [];

        if (Array.isArray(rawResponseData)) {
          newTranslations = rawResponseData;
        } else if (rawResponseData && Array.isArray(rawResponseData.result)) {
          newTranslations = rawResponseData.result;
        } else if (rawResponseData && rawResponseData.language) {
          newTranslations = [rawResponseData];
        }

        newTranslations.forEach(newItem => {
          if (newItem.language !== 'it' && newItem.order_detail_id) {
            const tempIdOfPlaceholder = tempIdsMap.get(newItem.language);
            const indexToRemove = this.displayItems.findIndex(item => item.id === tempIdOfPlaceholder);

            const translatedItem = {
              id: newItem.order_detail_id,
              language: awsToLangCode.get(newItem.language) || newItem.language,
              order_detail_id: newItem.order_detail_id,
              html_title: newItem.html_title || null,
              result: newItem.result,
              isPlaceholder: false,
              timestamp: Date.now()
            };

            if (indexToRemove !== -1) {
              this.displayItems.splice(indexToRemove, 1);
            }
            this.displayItems.splice(0, 0, translatedItem);
          }
        });

      } catch (error) {
        console.error("Errore durante la traduzione:", error);
        Message.error("Errore durante la traduzione.");

        languagesToRequest.forEach(langCode => {
          const tempIdToRemove = tempIdsMap.get(langCode);
          const indexToRemove = this.displayItems.findIndex(item => item.id === tempIdToRemove);
          if (indexToRemove !== -1) {
            this.displayItems.splice(indexToRemove, 1);
          }
        });
      } finally {
        this.isTranslating = false;
      }
    },
    stripHtml(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
    getFormattedDate(timestamp) {
      const date = new Date(timestamp || Date.now());
      return date.toLocaleString();
    },
    getPreviewText(result) {
      let text = '';

      if (typeof result.result === 'string') {
        const tmp = document.createElement('div');
        tmp.innerHTML = result.result;
        text = tmp.textContent || tmp.innerText || '';
      } else if (
        Array.isArray(result.result) &&
        typeof result.result[0]?.result === 'string'
      ) {
        const tmp = document.createElement('div');
        tmp.innerHTML = result.result[0].result;
        text = tmp.textContent || tmp.innerText || '';
      }

      if (text || result.html_title) {
        const title = result.html_title || text.substring(0, 30) + '...';
        const langName = this.languages.find(l => l.language_code === result.language)
          || this.languages.find(l => l.aws_language_code === result.language);

        let formattedDate = '';
        if (result.timestamp) {
          const date = new Date(result.timestamp);
          formattedDate = date.toLocaleString();
        }

        return `${title}
      <br>
      <small class="paragraph-translate">
        ${formattedDate ? ` <span>${formattedDate}</span>` : ''}
         <span> - ${langName.name}</span>
      </small>`;
      }

      return '[Nessun testo disponibile]';
    },
  },
  mounted() {
    // Recupera la preferenza del modello salvata
    const savedModel = localStorage.getItem('preferredTranslationModel');
    if (savedModel && ['azure', 'openai', 'google', 'anthropic'].includes(savedModel)) {
      this.translationModel = savedModel;
    }

    console.log(this.relatedOrders)
   /* this.displayItems = this.relatedOrders
      .filter(item => item.language !== 'it')
      .map(item => ({
        id: item.order_detail_id,
        language: item.language,
        order_detail_id: item.order_detail_id,
        result: item.result,
        isPlaceholder: false,
        timestamp: Date.now()
      }))
      .sort((a, b) => b.timestamp - a.timestamp);
    //this.$emit('show-component');*/

    if (this.order.sub_orders && Array.isArray(this.order.sub_orders)) {
      const subTranslated = this.order.sub_orders
        .filter(item => item.json_data?.translate_into)
        .map(item => ({
          id: item.order_detail_id,
          language: item.json_data.translate_into,
          order_detail_id: item.order_detail_id,
          html_title: item.title || null,
          result: item.content,
          isPlaceholder: false,
          timestamp: Date.now()
        }));

      this.displayItems = [...subTranslated, ...this.displayItems].sort((a, b) => b.timestamp - a.timestamp);
    }
    this.$store.dispatch("fetchLanguages");
  }
};
</script>

<style scoped lang="scss">
.extended-forms .el-select {
  margin-bottom: 0;
}

.card-title {
  font-size: 1.25rem;
}
a {
  margin-bottom: 0px;
}
.translated-content span {
  color: #D32F2F;
  font-weight: bold;
}
.paragraph-translate {
  color: #566A7F !important;
  font-size: 14px !important;;
  font-style: normal !important;;
  font-weight: 400 !important;;
  line-height: normal !important;;
}
</style>
